var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSeen = function SvgSeen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C75BC",
    d: "m2.707 7.793-2-2L0 6.5l2.707 2.707 5.5-5.5L7.5 3zM6.857 7.793l-1-1-.707.707 1.707 1.707 5.5-5.5L11.65 3z"
  })));
};
export default SvgSeen;